/**
 * Singolo livello (Layer) della mappa. Permette di specificare la fonte
 * dei dati, lo stile e le eventuali interazioni.
 */
export interface IMapLayer {
  type: MapLayerType;
  /**
   * Nome del layer
   */
  name: string;
  /**
   * URL della fonte dei dati
   */
  url: string;
  /**
   * Stile del layer
   */
  style?: IMapLayerStyle;
  /**
   * Zoom minimo per visualizzare il layer
   */
  minZoom?: number;
  /**
   * Proprietà da utilizzare per l'etichettatura delle geometrie
   */
  labelPropertyName?: string | null;
}

/**
 * Per i layer vettoriali, il valore di default per il livello minimo è 15.
 */
export const DefaultMapLayerMinZoom = 15;

export interface IMapLayerStyle {
  /**
   * Colore di riempimento
   */
  fillColor?: string;
  /**
   * Colore del bordo
   */
  strokeColor?: string;
  /**
   * Spessore del bordo
   */
  strokeWidth?: number;
  /**
   * Opacità
   */
  opacity?: number;
}

export enum MapLayerType {
  /**
   * OpenStreetMap
   */
  OSM = 'osm',
  /**
   * Raster XYZ (Tile)
   */
  XYZ = 'xyz',
  /**
   * Raster WMS
   */
  WMS = 'wms',
  /**
   * ArcGIS REST
   */
  ArcGISRest = 'arcgisRest',
  /**
   * ArcGIS REST (Tile)
   */
  ArcGISRestTile = 'arcgisRestTile',
  /**
   * ArcGIS REST (Vector)
   */
  ArcGISRestVector = 'arcgisRestVector',
  /**
   * Mappa Vettoriale (WFS, GeoJSON, ecc.)
   */
  Vector = 'vector',
}

export const MapLayerTypeOptions = [
  { value: MapLayerType.OSM, label: 'OpenStreetMap' },
  { value: MapLayerType.XYZ, label: 'Tile XYZ (Raster)' },
  { value: MapLayerType.WMS, label: 'WMS (Raster)' },
  { value: MapLayerType.ArcGISRest, label: 'ArcGIS REST (Raster)' },
  { value: MapLayerType.ArcGISRestTile, label: 'ArcGIS REST (Tile)' },
  {
    value: MapLayerType.ArcGISRestVector,
    label: 'ArcGIS REST (Vettoriale)',
    allowIntersect: true,
  },
];

export function isVectorLayerType(layerType: MapLayerType): boolean {
  return (
    layerType === MapLayerType.ArcGISRestVector ||
    layerType === MapLayerType.Vector
  );
}

export function isMapLayerRenderingSupported(layerType: MapLayerType): boolean {
  return (
    layerType === MapLayerType.ArcGISRestTile ||
    layerType === MapLayerType.XYZ ||
    layerType === MapLayerType.WMS
  );
}
